module.exports = __webpack_public_path__ + "static/media/1 1 tattoo arm japanese dragon colour.1280x1812.6034a698.webp";